import React, { useMemo } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Tooltip from "../ui/Tooltip";
import {
  INSPECTOR_CHROME_HEADER_ICON_BUTTON_CLASS,
  INSPECTOR_CHROME_NO_FOCUS_RING,
} from "../../utils/inspectorChromeButtonClasses";

const InspectorHeaderButtons = ({ handleMinimize, isMobile }) =>
  useMemo(
    () => (
      <div className="flex items-center gap-1">
        {isMobile ? (
          <button
            type="button"
            onPointerDown={(e) => e.stopPropagation()}
            onClick={handleMinimize}
            className={`draggable-panel-close-button cursor-pointer select-none rounded leading-none text-gray-400 ${INSPECTOR_CHROME_NO_FOCUS_RING}`}
            aria-label="Close inspector"
          >
            <ChevronLeft className="h-5 w-5 flex-shrink-0" strokeWidth={2.5} aria-hidden />
          </button>
        ) : (
          <Tooltip content="Minimize inspector">
            <button
              type="button"
              onClick={handleMinimize}
              className={`${INSPECTOR_CHROME_HEADER_ICON_BUTTON_CLASS} inline-flex h-8 w-8 items-center justify-center`}
              aria-label="Minimize inspector"
            >
              <ChevronRight className="h-4 w-4" strokeWidth={2.5} aria-hidden />
            </button>
          </Tooltip>
        )}
      </div>
    ),
    [handleMinimize, isMobile]
  );

export default InspectorHeaderButtons;
